/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  serviceId: ZodTypes.Id,
});

export const UserFavoriteServiceDelete = {
  id: 'user.favorite-service.delete',
  tag: 'User',
  summary: 'Remove a Service from Favorites',
  description: 'Removes a specific service from the user’s favorites',
  method: 'delete',
  flags: { isAuthorized: true },
  route: (args: z.infer<typeof Params>) => `/user/favorite/service/${args.serviceId}`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'Service successfully removed from favorites',
      content: {
        'application/json': {
          schema: z.object({ success: z.boolean() }),
        },
      },
    },
  },
} as const satisfies Endpoint;
